import clsx from "clsx";
import React from "react";

import { Container } from "../container";
import { BreadcrumbItem, BreadcrumbItemProps } from "./breadcrumb-item";
import { colorSchemes } from "./styles";
import { BreadcrumbsColor, BreadcrumbsPosition, BreadcrumbsVariant } from "./types";

export interface BreadcrumbsProps {
  items: BreadcrumbItemProps[];
  color?: BreadcrumbsColor;
  variant?: BreadcrumbsVariant;
  position?: BreadcrumbsPosition;
}

export function Breadcrumbs({
  items,
  color = BreadcrumbsColor.Neutral,
  variant = BreadcrumbsVariant.Filled,
  position = BreadcrumbsPosition.Block,
}: BreadcrumbsProps) {
  const colorScheme = colorSchemes[variant];
  const { bgClassName, ...breadcrumbItemColorProps } = colorScheme[color];
  const dividerClassName = breadcrumbItemColorProps.disabledClassName;

  return (
    <Container
      className={clsx(
        position === BreadcrumbsPosition.Overlap && "absolute top-0 left-0 z-40",
        variant === BreadcrumbsVariant.Filled && bgClassName
      )}
      pagePaddingX
    >
      <div className="flex gap-1 py-4 flex-wrap text-sm lg:text-base">
        {items.map((item, i) => {
          const isLastBreadcrumb = i === items.length - 1;
          return (
            <React.Fragment key={i}>
              <BreadcrumbItem {...item} disabled={isLastBreadcrumb} {...breadcrumbItemColorProps} />
              {!isLastBreadcrumb && <span className={dividerClassName}>/</span>}
            </React.Fragment>
          );
        })}
      </div>
    </Container>
  );
}
